const SITE_URL = "https://parcelin.co.za";
const SITE_NAME = "Parcelin";
const SOCIAL_IMAGE = {
  url: `${SITE_URL}/og-image.jpg`,
  width: 1200,
  height: 630,
  alt: "Parcelin: affordable parcel delivery across South Africa",
};
const SUPPORT_PHONE = "+27699042846";
const SUPPORT_EMAIL = "support@parcelin.co.za";
const LEGAL_NAME = "Earlybirds Corporation (PTY) Ltd";

export { SITE_URL, SITE_NAME, SOCIAL_IMAGE, SUPPORT_PHONE, SUPPORT_EMAIL, LEGAL_NAME };
